<template>
    <li>
        <a @click="modal = true" class="cursor-pointer">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <g id="add-circle" transform="translate(-108 -252)">
                    <path
                        id="Vector"
                        d="M10,20A10,10,0,1,0,0,10,10.029,10.029,0,0,0,10,20Z"
                        transform="translate(110 254)"
                        fill="none"
                        stroke="#12202b"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,0H8"
                        transform="translate(116 264)"
                        fill="none"
                        stroke="#12202b"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-3"
                        data-name="Vector"
                        d="M0,8V0"
                        transform="translate(120 260)"
                        fill="none"
                        stroke="#12202b"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-4"
                        data-name="Vector"
                        d="M0,0H24V24H0Z"
                        transform="translate(108 252)"
                        fill="none"
                        opacity="0"
                    />
                </g>
            </svg>
            ბალანსის შევსება
        </a>

        <div class="modals" v-if="modal">
            <div class="modals-inner">
                <h2 class="modals-inner-title">ბალანსის შევსება</h2>
                <button class="modals-inner-closer" @click="modal = false">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.121"
                        height="12.121"
                        viewBox="0 0 12.121 12.121"
                    >
                        <g
                            id="close-circle"
                            transform="translate(-244.109 -260.109)"
                        >
                            <path
                                id="Vector"
                                d="M0,10,10,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                            <path
                                id="Vector-2"
                                data-name="Vector"
                                d="M10,10,0,0"
                                transform="translate(245.17 261.17)"
                                fill="none"
                                stroke="#12202b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            />
                        </g>
                    </svg>
                </button>
                <div class="ipay">
                    <div class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="47.182"
                            height="39"
                            viewBox="0 0 47.182 39"
                        >
                            <g id="logo" transform="translate(-2269 7800)">
                                <path
                                    id="Path_575"
                                    data-name="Path 575"
                                    d="M45.457,7.684C45.134,7.167,40.291,0,31.9,0H13.947A10.527,10.527,0,0,0,3.422,10.525V30.218c0,.581-.9.258-.9.258a2.775,2.775,0,0,0-.775-.129A1.736,1.736,0,0,0,0,32.091C0,34.157,3.228,35,4.52,35a5.908,5.908,0,0,0,1.1-.065A10.656,10.656,0,0,0,13.947,39H31.833A10.527,10.527,0,0,0,42.357,28.475V17.692s2.2-2.776,2.454-3.035h0s1.743-2.389,2.2-3.293.065-1.291-1.55-3.68"
                                    transform="translate(2269 -7800)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_576"
                                    data-name="Path 576"
                                    d="M35.641,30.068a3.883,3.883,0,0,0,1.291.194c1.937,0,2.776-.775,2.776-1.679,0-1.033-1.421-1.033-1.55-2-.194-1.162-.065-6.328,1.937-9.169l1.356.581a2.1,2.1,0,0,0,.839.194,1.221,1.221,0,0,0,.9-.452,26.118,26.118,0,0,0,3.487-4.778c.194-.323-2.647-3.874-4.2-5.1A6.459,6.459,0,0,0,38.546,6.5a6.233,6.233,0,0,0-5.94,4.2A30.164,30.164,0,0,1,23.7,14.959c-4.326,1.162-8.781.065-11.752.258A6.121,6.121,0,0,0,5.81,21.545C5.874,24.9,8.2,27.937,8.2,31.1a3.456,3.456,0,0,1-3.422,3.551c-1.679,0-1.743-.646-2.26-.646A.414.414,0,0,0,2,34.394c0,.839,2.066,1.614,3.228,1.614a5.122,5.122,0,0,0,4.391-2.2,3.859,3.859,0,0,0,3.874,2.26c2.454,0,3.487-1.162,3.487-2.131,0-.775-.452-1.1-.839-1.614a2.337,2.337,0,0,1-.452-1.485,11.512,11.512,0,0,0,1.291.065c1.743,0,2.324-.71,2.324-1.421,0-.9-1.033-.839-1.033-2.324,0-1.162.646-1.485,1.162-1.485.581,0,2.841.194,5.618.517.9.065,3.164.969,3.164,4.52V32c0,2.131.839,4.843,4.714,4.843,2.583,0,4.068-1.421,4.068-2.518,0-.71-.581-.969-.9-1.421a3.336,3.336,0,0,1-.452-2.841"
                                    transform="translate(2268.292 -7802.303)"
                                    fill="#f26724"
                                />
                                <path
                                    id="Path_577"
                                    data-name="Path 577"
                                    d="M63.552,19.1a.452.452,0,1,0,.452.452.441.441,0,0,0-.452-.452"
                                    transform="translate(2246.643 -7806.767)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_578"
                                    data-name="Path 578"
                                    d="M65.987,17a.387.387,0,1,0,.387.387A.372.372,0,0,0,65.987,17"
                                    transform="translate(2245.757 -7806.023)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_579"
                                    data-name="Path 579"
                                    d="M67.223,14.7a.323.323,0,1,0,.323.323.346.346,0,0,0-.323-.323"
                                    transform="translate(2245.297 -7805.208)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_580"
                                    data-name="Path 580"
                                    d="M47.117,17.433a.517.517,0,1,0-.517-.517c.065.323.258.517.517.517"
                                    transform="translate(2252.489 -7805.811)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_581"
                                    data-name="Path 581"
                                    d="M50.052,36.2a.461.461,0,0,0-.452.517.5.5,0,0,0,.452.517.509.509,0,0,0,.517-.517c-.065-.258-.258-.517-.517-.517"
                                    transform="translate(2251.426 -7812.826)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_582"
                                    data-name="Path 582"
                                    d="M54.517,37a.517.517,0,1,0,.517.517c-.065-.323-.258-.517-.517-.517"
                                    transform="translate(2249.867 -7813.109)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_583"
                                    data-name="Path 583"
                                    d="M50.617,29.4a.517.517,0,1,0,0,1.033.475.475,0,0,0,.517-.517.509.509,0,0,0-.517-.517"
                                    transform="translate(2251.249 -7810.417)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_584"
                                    data-name="Path 584"
                                    d="M53.246,23.733a.517.517,0,0,0,0-1.033.521.521,0,0,0,0,1.033"
                                    transform="translate(2250.298 -7808.043)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_585"
                                    data-name="Path 585"
                                    d="M41.417,20.633a.517.517,0,1,0-.517-.517c.065.323.258.517.517.517"
                                    transform="translate(2254.509 -7806.944)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_586"
                                    data-name="Path 586"
                                    d="M45.717,34.7a.517.517,0,1,0,.517.517c-.065-.323-.258-.517-.517-.517"
                                    transform="translate(2252.985 -7812.294)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_587"
                                    data-name="Path 587"
                                    d="M43.617,24.333a.461.461,0,0,0,.452-.517.5.5,0,0,0-.452-.517.517.517,0,0,0,0,1.033"
                                    transform="translate(2253.729 -7808.255)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_588"
                                    data-name="Path 588"
                                    d="M38.817,29.2a.517.517,0,1,0,.517.517.555.555,0,0,0-.517-.517"
                                    transform="translate(2255.43 -7810.346)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_589"
                                    data-name="Path 589"
                                    d="M46.617,27.833a.517.517,0,1,0-.517-.517c.065.323.258.517.517.517"
                                    transform="translate(2252.666 -7809.496)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_590"
                                    data-name="Path 590"
                                    d="M34.717,21.7a.517.517,0,1,0,.517.517.509.509,0,0,0-.517-.517"
                                    transform="translate(2256.883 -7807.688)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_591"
                                    data-name="Path 591"
                                    d="M36.417,25.6a.517.517,0,1,0,.517.517c-.065-.323-.258-.517-.517-.517"
                                    transform="translate(2256.28 -7809.07)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_592"
                                    data-name="Path 592"
                                    d="M41.917,32.1a.517.517,0,1,0,.517.517c-.065-.258-.258-.517-.517-.517"
                                    transform="translate(2254.332 -7811.374)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_593"
                                    data-name="Path 593"
                                    d="M49.617,20.933a.517.517,0,1,0-.517-.517c.065.323.258.517.517.517"
                                    transform="translate(2251.604 -7807.051)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_594"
                                    data-name="Path 594"
                                    d="M55.117,30.8a.517.517,0,1,0,.517.517.509.509,0,0,0-.517-.517"
                                    transform="translate(2249.655 -7810.913)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_595"
                                    data-name="Path 595"
                                    d="M57.017,24.7a.517.517,0,0,0,0,1.033.475.475,0,0,0,.517-.517.509.509,0,0,0-.517-.517"
                                    transform="translate(2248.981 -7808.751)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_596"
                                    data-name="Path 596"
                                    d="M56.517,18.5a.517.517,0,1,0,.517.517.475.475,0,0,0-.517-.517"
                                    transform="translate(2249.159 -7806.555)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_597"
                                    data-name="Path 597"
                                    d="M60.117,19.6a.517.517,0,1,0,.517.517.556.556,0,0,0-.517-.517"
                                    transform="translate(2247.883 -7806.944)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_598"
                                    data-name="Path 598"
                                    d="M53.917,16.2a.517.517,0,1,0,.517.517c-.065-.323-.258-.517-.517-.517"
                                    transform="translate(2250.08 -7805.74)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_599"
                                    data-name="Path 599"
                                    d="M52.417,13.3a.517.517,0,1,0,.517.517c-.065-.258-.258-.517-.517-.517"
                                    transform="translate(2250.611 -7804.712)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_600"
                                    data-name="Path 600"
                                    d="M55.517,13.3a.517.517,0,1,0,.517.517.555.555,0,0,0-.517-.517"
                                    transform="translate(2249.513 -7804.712)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_601"
                                    data-name="Path 601"
                                    d="M52.2,11.087a.417.417,0,0,1,.387-.387.372.372,0,0,1,.387.387.387.387,0,1,1-.775,0"
                                    transform="translate(2250.505 -7803.791)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_602"
                                    data-name="Path 602"
                                    d="M54.1,8.823a.323.323,0,1,1,.323.323.346.346,0,0,1-.323-.323"
                                    transform="translate(2249.832 -7803.012)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_603"
                                    data-name="Path 603"
                                    d="M56.5,7.758a.258.258,0,1,1,.258.258.278.278,0,0,1-.258-.258"
                                    transform="translate(2248.981 -7802.657)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_604"
                                    data-name="Path 604"
                                    d="M66.9,12.958a.258.258,0,1,1,.258.258.278.278,0,0,1-.258-.258"
                                    transform="translate(2245.297 -7804.5)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_605"
                                    data-name="Path 605"
                                    d="M66.3,20.458a.258.258,0,1,1,.258.258c-.065,0-.194-.129-.258-.258"
                                    transform="translate(2245.509 -7807.157)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_606"
                                    data-name="Path 606"
                                    d="M67.4,19.058a.258.258,0,1,1,.258.258.278.278,0,0,1-.258-.258"
                                    transform="translate(2245.12 -7806.661)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_607"
                                    data-name="Path 607"
                                    d="M65.2,21.958a.258.258,0,1,1,.258.258.278.278,0,0,1-.258-.258"
                                    transform="translate(2245.899 -7807.688)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_608"
                                    data-name="Path 608"
                                    d="M63.9,23.258a.258.258,0,1,1,.258.258c-.129,0-.194-.129-.258-.258"
                                    transform="translate(2246.36 -7808.149)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_609"
                                    data-name="Path 609"
                                    d="M68.4,17.558a.258.258,0,1,1,.258.258.278.278,0,0,1-.258-.258"
                                    transform="translate(2244.765 -7806.129)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_610"
                                    data-name="Path 610"
                                    d="M69.1,16.258a.258.258,0,1,1,.258.258c-.129,0-.194-.065-.258-.258"
                                    transform="translate(2244.517 -7805.669)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_611"
                                    data-name="Path 611"
                                    d="M20.963,43.014a7.82,7.82,0,0,1-.581-6.2c1.356-3.487,5.295-3.035,5.295-3.035a4.536,4.536,0,0,0-2.066-.387A5.163,5.163,0,0,0,18.9,38.946a5.944,5.944,0,0,0,2.066,4.068"
                                    transform="translate(2262.307 -7811.827)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_612"
                                    data-name="Path 612"
                                    d="M11.327,29.158a4.145,4.145,0,0,1-1.227-2.97,4.273,4.273,0,0,1,4.2-4.2c2.389-.129,6.78.581,9.621.194.969,4.326,4.2,7.361,6.586,9.3-2.906-1.291-5.811-4.714-9.169-6.586-3.487-1.937-7.038-2.26-8.911-.517a4.824,4.824,0,0,0-1.1,4.778"
                                    transform="translate(2265.421 -7807.786)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_613"
                                    data-name="Path 613"
                                    d="M26.266,39.9c.194,1.227-2.066,1.679-2.066,1.679,2.066.387,2.712-.71,2.712-.71a4.93,4.93,0,0,0-.646-.969"
                                    transform="translate(2260.426 -7814.137)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_614"
                                    data-name="Path 614"
                                    d="M51.176,40.9h0s-1.356,1.873-.387,5.359A6.973,6.973,0,0,1,48.4,47.486s3.1.387,4.068-1.227c-1.937-1.485-1.356-5.1-1.291-5.359"
                                    transform="translate(2251.852 -7814.491)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_615"
                                    data-name="Path 615"
                                    d="M60.8,10.28A2.056,2.056,0,0,0,58.285,11.7a2.006,2.006,0,0,0,1.873,2.2,2.056,2.056,0,0,0,2.518-1.421,2.006,2.006,0,0,0-1.873-2.2m1.55,2.131a1.5,1.5,0,0,1-1.808,1.033,1.421,1.421,0,0,1-1.291-1.55,1.5,1.5,0,0,1,1.808-1.033,1.421,1.421,0,0,1,1.291,1.55"
                                    transform="translate(2248.359 -7803.629)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_616"
                                    data-name="Path 616"
                                    d="M62.1,12.776a.832.832,0,0,1,.969-.581.78.78,0,0,1,.71.839.832.832,0,0,1-.969.581.78.78,0,0,1-.71-.839"
                                    transform="translate(2247.002 -7804.317)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_617"
                                    data-name="Path 617"
                                    d="M57.314,38.3h0c.71,1.356-1.614,1.873-1.614,1.873,1.679.258,2.583-.71,2.583-1.162a4.18,4.18,0,0,1-.969-.71"
                                    transform="translate(2249.265 -7813.57)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_618"
                                    data-name="Path 618"
                                    d="M35.5,31.329s.323.387.839.9A20.717,20.717,0,0,0,38.4,33.976a15.792,15.792,0,0,0,2.26,1.421,4.245,4.245,0,0,0,.775.387,2.715,2.715,0,0,1,.323.129,2.715,2.715,0,0,0-.323-.129A4.437,4.437,0,0,1,40.6,35.4a19.4,19.4,0,0,1-2.389-1.356,16.373,16.373,0,0,1-2.131-1.679,9.47,9.47,0,0,1-.9-.9.2.2,0,0,1,0-.258.493.493,0,0,1,.323.129h0"
                                    transform="translate(2256.555 -7811.054)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_619"
                                    data-name="Path 619"
                                    d="M62.139,10.723a3.488,3.488,0,0,0-5.876-.258.55.55,0,1,1-.839-.71A3.949,3.949,0,0,1,58.459,8.4a3.9,3.9,0,0,1,3.68,2.324"
                                    transform="translate(2249.412 -7802.975)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_620"
                                    data-name="Path 620"
                                    d="M56.117,20.158a8.5,8.5,0,0,1-4.326-1.743,9.042,9.042,0,0,1-2.712-3.035c-.065-.194-.065-.452.129-.517a.349.349,0,0,1,.517.129,9.818,9.818,0,0,0,2.583,3.293,9.514,9.514,0,0,0,3.81,1.873"
                                    transform="translate(2251.625 -7805.242)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_621"
                                    data-name="Path 621"
                                    d="M52.474,24.507a10.475,10.475,0,0,1-6.78-3.358,14.178,14.178,0,0,1-2.131-2.97.376.376,0,0,1,.646-.387,12.726,12.726,0,0,0,2.518,3.745,9.757,9.757,0,0,0,5.747,2.97"
                                    transform="translate(2253.589 -7806.234)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_622"
                                    data-name="Path 622"
                                    d="M37.765,20.491a.367.367,0,0,1,.452.258,13.8,13.8,0,0,0,3.293,5.295,12.236,12.236,0,0,0,8.071,3.616,12.366,12.366,0,0,1-8.717-3.616,14.283,14.283,0,0,1-3.293-5.036.342.342,0,0,1,.194-.517"
                                    transform="translate(2255.707 -7807.254)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_623"
                                    data-name="Path 623"
                                    d="M57.968,15.185a3.791,3.791,0,0,0,2.131.646A2.621,2.621,0,0,0,62.875,13.7a3.048,3.048,0,0,1-3.035,2.712,4.5,4.5,0,0,1-2.26-.517.407.407,0,0,1-.194-.517c.194-.194.452-.323.581-.194"
                                    transform="translate(2248.676 -7804.854)"
                                    fill="#fff"
                                />
                            </g>
                        </svg>
                    </div>
                    <span> IPAY - Visa/MC/Amex </span>
                </div>

                <div class="ipay">
                    <div class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="21"
                            height="19"
                            viewBox="0 0 21 19"
                        >
                            <defs>
                                <path id="a" d="M0 .135h9.695v17.293H0z" />
                                <path id="c" d="M.058.03h19.528v6.038H.058z" />
                            </defs>
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(0 .025)">
                                    <mask id="b" fill="#fff">
                                        <use xlink:href="#a" />
                                    </mask>
                                    <path
                                        fill="#01A3DF"
                                        d="M9.288 10.496c.089.883.138 1.335-.58 2.091-.745.786-2.61 2.23-4.516 3.329-.805.471-1.895 1.03-2.72 1.325-.608.226-1.119.315-1.374-.127-.167-.285-.088-.55 0-.776.667-1.797 2.572-5.165 3.82-7.344.127-.226.264-.452.392-.688C6.235 4.997 8.778.942 9.278.294c.07-.098.207-.206.324-.137.099.059.099.177.089.265 0 .01-.03.127-.05.177-.814 3.348-.726 6.627-.353 9.897"
                                        mask="url(#b)"
                                    />
                                </g>
                                <path
                                    fill="#01A3DF"
                                    d="M12.096 11.551c-.805-.373-1.227-.56-1.522-1.56-.304-1.032-.628-3.369-.628-5.578 0-.923.059-2.14.206-3.004.118-.648.295-1.14.805-1.14.334 0 .52.207.678.393 1.227 1.473 3.171 4.812 4.448 6.991.127.216.255.442.392.678 1.905 3.319 4.144 7.55 4.458 8.307.05.108.079.274-.049.353-.098.05-.196-.01-.265-.059l-.128-.128c-2.494-2.386-5.37-3.947-8.395-5.253"
                                />
                                <g transform="translate(.639 12.799)">
                                    <mask id="d" fill="#fff">
                                        <use xlink:href="#c" />
                                    </mask>
                                    <path
                                        fill="#01A3DF"
                                        d="M9.16.658c.727-.511 1.1-.776 2.111-.54 1.041.255 3.23 1.148 5.145 2.248.795.461 1.826 1.13 2.504 1.689.49.422.834.815.58 1.257-.168.284-.433.353-.678.392-1.895.325-5.764.344-8.277.364h-.786c-3.83-.01-8.611-.187-9.426-.295-.118-.01-.275-.069-.275-.216 0-.108.098-.177.177-.206.02 0 .137-.04.177-.05C3.72 4.34 6.519 2.632 9.16.659"
                                        mask="url(#d)"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <span> თიბისი ბანკი - Visa/MC </span>
                </div>

                <!-- <div class="modals-content country">
                    <div class="address-fields">
                        <div class="name">
                            <p>საქართველოს ბანკი</p>
                            <span>GE34BG0000000528051320</span>
                        </div>
                        <div class="spacer"></div>
                        <button
                            @click="copytoClipboard('GE34BG0000000528051320')"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g id="copy" transform="translate(-682 -382)">
                                    <path
                                        id="Vector"
                                        d="M14,4.9V9.1c0,3.5-1.4,4.9-4.9,4.9H4.9C1.4,14,0,12.6,0,9.1V4.9C0,1.4,1.4,0,4.9,0H9.1C12.6,0,14,1.4,14,4.9Z"
                                        transform="translate(684 390)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-2"
                                        data-name="Vector"
                                        d="M14,4.9V9.1c0,3.5-1.4,4.9-4.9,4.9H8V10.9C8,7.4,6.6,6,3.1,6H0V4.9C0,1.4,1.4,0,4.9,0H9.1C12.6,0,14,1.4,14,4.9Z"
                                        transform="translate(690 384)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-3"
                                        data-name="Vector"
                                        d="M0,0H24V24H0Z"
                                        transform="translate(682 382)"
                                        fill="none"
                                        opacity="0"
                                    />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="modals-content country">
                    <div class="address-fields">
                        <div class="name">
                            <p>თიბისი ბანკი</p>
                            <span>GE52TB7250736080100009</span>
                        </div>
                        <div class="spacer"></div>
                        <button
                            @click="copytoClipboard('GE52TB7250736080100009')"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g id="copy" transform="translate(-682 -382)">
                                    <path
                                        id="Vector"
                                        d="M14,4.9V9.1c0,3.5-1.4,4.9-4.9,4.9H4.9C1.4,14,0,12.6,0,9.1V4.9C0,1.4,1.4,0,4.9,0H9.1C12.6,0,14,1.4,14,4.9Z"
                                        transform="translate(684 390)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-2"
                                        data-name="Vector"
                                        d="M14,4.9V9.1c0,3.5-1.4,4.9-4.9,4.9H8V10.9C8,7.4,6.6,6,3.1,6H0V4.9C0,1.4,1.4,0,4.9,0H9.1C12.6,0,14,1.4,14,4.9Z"
                                        transform="translate(690 384)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-3"
                                        data-name="Vector"
                                        d="M0,0H24V24H0Z"
                                        transform="translate(682 382)"
                                        fill="none"
                                        opacity="0"
                                    />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div> -->
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form
                        method="post"
                        @submit.prevent="handleSubmit(onSave)"
                        @keyup.enter="handleSubmit(onSave)"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|decimal:3"
                            tag="div"
                        >
                            <div
                                :class="{
                                    'calculator-inpout': true,
                                    'is-invalid': errors[0] ? true : false,
                                    'mt-4': true,
                                }"
                            >
                                <input
                                    type="text"
                                    autocomplete="off"
                                    name="amount"
                                    v-model="amount"
                                    ref="amountRef"
                                    placeholder="თანხა"
                                />
                            </div>

                            <span
                                v-if="errors[0]"
                                class="invalid-feedback"
                                role="alert"
                            >
                                <strong>{{ errors[0] }}</strong>
                            </span>
                        </ValidationProvider>

                        <button
                            class="calculator-button"
                            type="submit"
                            :disabled="disable"
                        >
                            <template v-if="!disable"> შევსება </template>
                            <template v-else>
                                <span
                                    class="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                <span class="visually-hidden">Loading...</span>
                            </template>
                        </button>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </li>
</template>

<script>
import {
    computed,
    defineComponent,
    onBeforeMount,
    onMounted,
    ref,
    watch,
} from "@vue/composition-api";
import { Notyf } from "notyf";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useUser } from "../../hooks/user";
export default defineComponent({
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    setup() {
        const notyf = new Notyf({
            duration: 4000,
            position: {
                x: "right",
                y: "top",
            },
        });
        const amountRef = ref("");
        const modal = ref(false);
        const amount = ref("");
        const disable = ref(false);
        const { userInfo, getUser, getDebet } = useUser();

        const copytoClipboard = (text) => {
            const el = document.createElement("input");
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            el.remove();
            notyf.success("დაკოპირდა");
        };

        const onSave = () => {
            disable.value = true;
            axios({
                url: "/api/payment/transaction",
                method: "POST",
                data: {
                    amount: amount.value,
                },
            }).then((e) => {
                if (e.data.link) {
                    window.location.href = e.data.link;
                    disable.value = false;
                } else if (e.data.error) {
                    notyf.error(e.data.error);
                    disable.value = false;
                } else {
                    notyf.error("დაფიქსირდა შეცდომა");
                    disable.value = false;
                }
            });
        };

        watch(
            () => modal.value,
            async (newVal) => {
                if (newVal) {
                    disable.value = true;
                    const user = await getUser();
                    const debet = await getDebet();

                    if (user.balance < debet) {
                        amount.value = (debet - user.balance).toFixed(2);
                    }

                    // amount.value = (92.59 - 7.74);
                    disable.value = false;
                }
            }
        );

        return {
            modal,
            copytoClipboard,
            onSave,
            amount,
            disable,
            amountRef,
        };
    },
});
</script>
